var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn",on:{"click":_vm.clearAll}},[_vm._v("点我清除缓存")])}
var staticRenderFns = []

export { render, staticRenderFns }